import React, { useEffect, useState } from 'react';
import image1 from "../../../assets/img/about/about-5.jpg";
import image2 from "../../../assets/img/about/about-6.jpg";
import image3 from "../../../assets/img/about/logo-1.png";
import Count from '../../common/count';

const AboutFour = () => {

    const [showImage, setShowImage] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            setShowImage(window.innerWidth > 992);
        };

        handleResize(); // ilk yüklemede kontrol
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="about__four section-padding">
            <div className="container">

                <div className="row al-center">

                    <div className="col-lg-8">
                        <div className="about__four-title">

                            <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">
                                HAKKIMIZDA
                            </span>

                            <h2
                                className="mb-20 wow fadeInRight"
                                data-wow-delay=".6s"
                                style={{ fontSize: "36px" }}
                            >
                                Güvenle İnşa Edilen Kalıcı Değerler
                            </h2>

                            <p className="wow fadeInUp" data-wow-delay=".4s">
                            Faaliyet gösterdiğimiz tüm alanlarda; endüstriyel yapılardan ticari projelere, modern ofis binalarından konut projelerine kadar geniş bir yelpazede anahtar teslim çözümler sunuyoruz.
                            </p>

                            <p className="wow fadeInUp" data-wow-delay=".5s">
                            Altyapı, çevre düzenleme ve proje yönetimi süreçlerinin tamamında; mühendislik disiplinini, kalite standartlarını ve güveni ön planda tutuyoruz.
                            </p>

                            <p className="wow fadeInUp" data-wow-delay=".6s">
                            Tamamladığımız her proje, sadece bir yapı değil; güven, tecrübe ve profesyonelliğin somut bir yansımasıdır.
                            </p>

                            <p className="wow fadeInUp" data-wow-delay=".7s">
                            Hayalleri gerçeğe dönüştürürken, kalıcı değerler inşa ediyoruz.
                            </p>

                        </div>
                    </div>

                    {/* ✅ 991px ve altı görünmez */}
                    {showImage && (
                        <div className="col-lg-4">
                            <div className="about__four-left wow img_top_animation">
                                <img
                                    src={image3}
                                    alt="image"
                                    style={{
                                        width: "100%",
                                        maxWidth: "320px",
                                        height: "auto",
                                        objectFit: "contain",
                                        display: "block",
                                        margin: "0 auto"
                                    }}
                                />
                            </div>
                        </div>
                    )}

                </div>

                <div className="row mt-30">
                    <div className="col-lg-12">
                        <div className="about__four-counter">
                            <div className="row">

                                <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".4s">
                                    <div className="about__four-counter-item t-center">
                                        <h2><Count number={120} />+</h2>
                                        <p>Tamamlanan Proje</p>
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay=".7s">
                                    <div className="about__four-counter-item borders t-center">
                                        <h2><Count number={30} />+</h2>
                                        <p>Uzman Personel</p>
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="1s">
                                    <div className="about__four-counter-item t-center">
                                        <h2><Count number={40} />+</h2>
                                        <p>Yıllık Deneyim</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AboutFour;